<section class="active-sessions">
  <h3 class="active-sessions__title">
    {{ 'user-profile.activeSessions.title' | translate }}
  </h3>

  <div class="active-sessions__termination-panel">
    <div class="active-sessions__table-wrapper">
      <table class="active-sessions__table" mat-table [dataSource]="sessions">
        <ng-container matColumnDef="device">
          <th class="active-sessions__header-cell" mat-header-cell *matHeaderCellDef>
            {{ 'user-profile.activeSessions.table.headers.device' | translate }}
          </th>

          <td class="active-sessions__data-cell" mat-cell *matCellDef="let element">
            <!-- The API returns Unknown. I decided to display Computer by default. -->
            <app-icon [icon]="IconName.COMPUTER" />
            <div class="active-sessions__info-summary">
              @for (key of infoSummaryKeys; track $index) {
                <span>{{ element[key] }}</span>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="lastActivityTime">
          <th class="active-sessions__header-cell" mat-header-cell *matHeaderCellDef>
            {{ 'user-profile.activeSessions.table.headers.lastActivityTime' | translate }}
            <div
              class="active-sessions__sort-btn"
              role="button"
              tabindex="0"
              (click)="sortSessions()"
            >
              <app-icon [icon]="IconName.ARROW_UP_DOWN" />
            </div>
          </th>

          <td class="active-sessions__data-cell" mat-cell *matCellDef="let element">
            @if (element.isCurrent) {
              <span class="active-sessions__current-session-label">
                {{ 'user-profile.activeSessions.currentSession' | translate }}
              </span>
            } @else {
              {{ element.lastActivityTime | date: 'yyyy-MM-dd HH:mm:ss' }}
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th class="active-sessions__header-cell" mat-header-cell *matHeaderCellDef>
            {{ 'user-profile.activeSessions.table.headers.action' | translate }}
          </th>

          <td
            class="active-sessions__data-cell active-sessions__terminate-cell"
            mat-cell
            *matCellDef="let element"
          >
            @let isCurrent = element.isCurrent;
            <button
              class="active-sessions__terminate-btn"
              [class.active-sessions__terminate-btn--disabled]="isCurrent"
              [disabled]="element.isCurrent"
              (click)="terminate(element.id, $event)"
            >
              {{ 'user-profile.activeSessions.table.terminate' | translate }}
            </button>
          </td>
        </ng-container>

        <tr
          class="active-sessions__header-row"
          mat-header-row
          *matHeaderRowDef="displayedColumns"
        ></tr>

        <tr
          class="active-sessions__row"
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          (click)="showSessionInfo(row)"
        ></tr>
      </table>
    </div>

    <div class="active-sessions__terminate-all">
      <p class="active-sessions__terminate-all-description">
        {{ 'user-profile.activeSessions.terminateAllBlock.description' | translate }}
      </p>

      @let isOnlyOne = sessions.data.length === 1;
      <button
        class="active-sessions__terminate-all-btn active-sessions__terminate-btn"
        [class.active-sessions__terminate-btn--disabled]="isOnlyOne"
        [disabled]="isOnlyOne"
        (click)="terminateAllSessions()"
      >
        {{ 'user-profile.activeSessions.terminateAllBlock.buttonTitle' | translate }}
      </button>
    </div>
  </div>
</section>
